import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorToast from '@/components/toasts/ErrorToast';
import actions from '../constants';

export function* reportDownloadErrorToast({ report, downloadFile }) {
  if (downloadFile) {
    yield call(showToast, <ErrorToast operation="actions.download" name={report.name} />);
  }
}

export default function* datasetReportsToasts() {
  yield takeEvery(
    [actions.DATA_MODEL_REPORT_DOWNLOAD_ERROR, actions.DICTIONARY_REPORT_DOWNLOAD_ERROR],
    reportDownloadErrorToast,
  );
}
